module.exports = __webpack_public_path__ + "img/7.fb655c96.gif";